import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';

import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(private permissionService: PermissionService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {

    const requiredPermissions = route.data['permissions'] as string[];

    if (!requiredPermissions || requiredPermissions.length === 0) {
      return of(true);
    }

    return this.permissionService.getPermissions$().pipe(
      map(permissions => {
        const hasPermission = this.permissionService.hasAnyPermission(requiredPermissions);
        if (hasPermission) {
          return true;
        } else {
          console.warn('Access denied. Required permissions:', requiredPermissions);
          return this.router.createUrlTree(['/dashboard']);
        }
      }),
      take(1)
    );

  }

}
